import { render, staticRenderFns } from "./ProjectTypeCommonFilters.vue?vue&type=template&id=b5206fd6&"
import script from "./ProjectTypeCommonFilters.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports